import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import useStyles from './style';

const TopHeaderViewer = (props) => {
  const { data, formData, setActiveTabMain, activeTabMain, blockState } = props;
  const { chartData, chartUniqueId } = data || {};
  const classes = useStyles();

  const chatRedirect = () => {
    props.history.push({
      pathname: `/${props?.match?.params?.appid}/page/${chartData.listPages}`
    });
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

        {chartData?.topBar?.enable && (
          <div className={classes.container}>
            <div className={classes.headerRow}>
              <div className={classes.leftSection}>
                <div className={classes.backButton} onClick={() => { chatRedirect() }}>
                  <img src={'/media/svg/previousIconObligations.svg'} alt="back" />
                </div>
                <Typography className={classes.title}>
                  {chartData?.topBar?.label || 'Opportunity Tracker'}
                </Typography>
              </div>

              <div>
                <Chip
                  label={blockState["status"]}
                  variant="outlined"
                  classes={{ outlined: classes.customChip }}
                />
              </div>
            </div>
          </div>
        )}

        {chartData?.tabs?.enable && (
          <div className={classes.tabsRow}>
            <div
              className={classes.tab}
              style={{
                borderBottom:
                  activeTabMain === "opportunityDetails"
                    ? '1px solid rgba(63, 81, 181, 1)'
                    : '1px solid transparent',
                marginBottom: activeTabMain === "opportunityDetails" ? '-1px' : '0px',
              }}
              onClick={() => setActiveTabMain("opportunityDetails")}
            >
              <Typography
                className={classes.tabText}
                style={{
                  color:
                    activeTabMain === "opportunityDetails"
                      ? 'rgba(63, 81, 181, 1)'
                      : 'rgba(120, 121, 142, 1)',
                }}
              >
                {chartData?.tabs?.labels?.opportunityDetails}
              </Typography>
            </div>

            <div
              className={classes.tab}
              style={{
                borderBottom:
                  activeTabMain === "contractDetails"
                    ? '1px solid rgba(63, 81, 181, 1)'
                    : '1px solid transparent',
                marginBottom: activeTabMain === "contractDetails" ? '-1px' : '0px',
              }}
              onClick={() => setActiveTabMain("contractDetails")}
            >
              <Typography
                className={classes.tabText}
                style={{
                  color:
                    activeTabMain === "contractDetails"
                      ? 'rgba(63, 81, 181, 1)'
                      : 'rgba(120, 121, 142, 1)',
                }}
              >
                {chartData?.tabs?.labels?.contractDetails}
              </Typography>
            </div>

            <div
              className={classes.tab}
              style={{
                borderBottom:
                  activeTabMain === "spendDetails"
                    ? '1px solid rgba(63, 81, 181, 1)'
                    : '1px solid transparent',
                marginBottom: activeTabMain === "spendDetails" ? '-1px' : '0px',
              }}
              onClick={() => setActiveTabMain("spendDetails")}
            >
              <Typography
                className={classes.tabText}
                style={{
                  color:
                    activeTabMain === "spendDetails"
                      ? 'rgba(63, 81, 181, 1)'
                      : 'rgba(120, 121, 142, 1)',
                }}
              >
                {chartData?.tabs?.labels?.spendDetails}
              </Typography>
            </div>

            <div
              className={classes.tab}
              style={{
                borderBottom:
                  activeTabMain === "supplementary"
                    ? '1px solid rgba(63, 81, 181, 1)'
                    : '1px solid transparent',
                marginBottom: activeTabMain === "supplementary" ? '-1px' : '0px',
              }}
              onClick={() => setActiveTabMain("supplementary")}
            >
              <Typography
                className={classes.tabText}
                style={{
                  color:
                    activeTabMain === "audit"
                      ? 'rgba(63, 81, 181, 1)'
                      : 'rgba(120, 121, 142, 1)',
                }}
              >
                {chartData?.tabs?.labels?.supplementary}
              </Typography>
            </div>

          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default TopHeaderViewer;
